import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const donationPageSlice = createSlice({
    name: "donationPageSlice",
    initialState,
    reducers: {
        setDonationPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setDonationCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setDonationTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setDonationTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetDonationPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setDonationPageLimit,
    setDonationCurrentPage,
    setDonationTotalCount,
    setDonationTotalPages,
    resetDonationPagination,
} = donationPageSlice.actions;

export default donationPageSlice.reducer;
